const homeTopSlides = {
  slides: [
    {
      caption: "Jamaica Jamming Sale",
      link: "/jamaica-jamming/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/jamaica-jamming-index-mobile-1.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/jamaica-jamming-index-tablet-1.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/jamaica-jamming-index-desktop-1.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "awards",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "Introducing a Flexible Way to Pay For Your Vacation",
      link: "/uplift/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-Uplift-index-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-Uplift-index-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-Uplift-index-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "awards",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "Caribbean destination weddings by Beaches",
      link: "/weddings/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-new-weddings-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-new-weddings-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/Beaches-new-Weddings-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "awards",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "All-New Beachfront Villas & Penthouse Collection",
      link: "/resorts/negril/new-accommodations/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/new-accommodations-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/new-accommodations-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/new-accommodations-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "awards",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "The Most Awarded All-Inclusive Family Resorts Ever.",
      link: "/awards/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/awards/January2022/all-inclusive-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/awards/January2022/all-inclusive-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/awards/January2022/all-inclusive.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "awards",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "Beaches Turks & Caicos is on the best stretch of Grace Bay.",
      link: "/resorts/turks-caicos/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/the-last-exotics/the-last-exotics-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/the-last-exotics/the-last-exotics-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/the-last-exotics/the-last-exotics-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "turks-and-caicos-new-slide",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "#1 All-Inclusive Dining Experience With as Many as 21 Unique Restaurants per Resort.",
      link: "/all-inclusive/dining/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/global-gourmet/May2021/GlobalGourmet-Mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/global-gourmet/May2021/GlobalGourmet-Tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/global-gourmet/May2021/GlobalGourmet-Desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "all-inclusive-dining",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "Caribbean's Best Waterparks.",
      link: "/activities/waterparks/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/waterparks/May2021/Waterpark-Mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/waterparks/May2021/Waterpark-Tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/waterparks/May2021/Waterpark-Desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "activities-waterparks",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "",
      link: "/all-inclusive/autism-friendly/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/autism-awareness/autism-awareness-mobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/autism-awareness/autism-awareness-tablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/autism-awareness/autism-awareness-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "resorts",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: false,
    },
    {
      caption: "",
      link: "https://www.sandalsfoundation.org/",
      ibmClickTag: "'HP Top Carousel-_-TGIF sale-_-N/A'",
      imgMobile:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/anniversary/14th-anniversary-nmobile.jpg",
      imgTablet:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/anniversary/14th-anniversary-ntablet.jpg",
      imgDesktop:
        "//cdn.sandals.com/beaches/v12/images/home/top-slides/anniversary/14th-anniversary-desktop.jpg",
      topText: "",
      bottomText: "",
      customizeLayout: true,
      additionalElements: "",
      idName: "resorts",
      video: false,
      videoLinkMP4: "",
      videoLinkWebM: "",
      leftAligned: false,
      anchorText: "",
      theme: true,
    },
  ],
};

module.exports = homeTopSlides;